import type { jiraBusinessMultipleVersionFieldFragment as jiraMultipleVersionPickerField } from '@atlassian/jira-business-fields/src/common/field-types/version/fragment/__generated_apollo__/jiraBusinessMultipleVersionFieldFragment.ts';
import type { jiraBusinessSingleVersionFieldFragment as jiraSingleVersionPickerField } from '@atlassian/jira-business-fields/src/common/field-types/version/fragment/__generated_apollo__/jiraBusinessSingleVersionFieldFragment.ts';
import type { Version } from '@atlassian/jira-issue-shared-types/src/common/types/issue-type.tsx';
import { MULTI_VERSION_CF_TYPE, VERSION_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { MULTIPLE_VERSION_FIELD_GQL_TYPE, SINGLE_VERSION_FIELD_GQL_TYPE } from '../constants';
import type { TransformedMultipleVersion, TransformedSingleVersion } from '../types';
import type { VersionTransformersMapping } from './types';

export const transformVersionField = (): VersionTransformersMapping => ({
	[SINGLE_VERSION_FIELD_GQL_TYPE]: (
		field: jiraSingleVersionPickerField,
	): TransformedSingleVersion | null => {
		if (field.__typename !== SINGLE_VERSION_FIELD_GQL_TYPE) {
			return null;
		}
		return {
			type: VERSION_CF_TYPE,
			fieldId: field.fieldId,
			name: field.name,
			value: field.version
				? {
						id: field.version.versionId,
						name: field.version.name ?? '',
					}
				: null,
		};
	},
	[MULTIPLE_VERSION_FIELD_GQL_TYPE]: (
		field: jiraMultipleVersionPickerField,
	): TransformedMultipleVersion | null => {
		if (field.__typename !== MULTIPLE_VERSION_FIELD_GQL_TYPE) {
			return null;
		}

		return {
			type: MULTI_VERSION_CF_TYPE,
			fieldId: field.fieldId,
			name: field.name,
			value:
				field.selectedVersionsConnection?.edges
					?.map?.((edge) =>
						edge?.node != null
							? {
									id: edge?.node.versionId,
									name: edge?.node.name ?? '',
								}
							: null,
					)
					.filter((version: Version | null | undefined): version is Version => version != null) ??
				null,
		};
	},
});
